import IntlMessages from "components/Message/IntlMessages";

export const LombardTransactiionStatus = {
  Approved: "A",
  Pending: "P",
  Success: "S",
  Canceled: "C",
  Rejectd: "R",
  Expired: "E",
  Failed: "F",
};

export const LombardTransactiionStatusMessage = {
  [LombardTransactiionStatus.Approved]: <IntlMessages id="lombard.status.approved" />,
  [LombardTransactiionStatus.Pending]: <IntlMessages id="lombard.status.pending-requests" />,
  [LombardTransactiionStatus.Success]: <IntlMessages id="lombard.status.success" />,
  [LombardTransactiionStatus.Canceled]: <IntlMessages id="lombard.status.canceled" />,
  [LombardTransactiionStatus.Rejectd]: <IntlMessages id="lombard.status.rejected" />,
  [LombardTransactiionStatus.Expired]: <IntlMessages id="lombard.status.expired" values={{ wbr: () => <wbr /> }} />,
  [LombardTransactiionStatus.Failed]: <IntlMessages id="lombard.status.failed" />,
};

export const CompletedTransStatusList = [
  LombardTransactiionStatus.Success,
  LombardTransactiionStatus.Canceled,
  LombardTransactiionStatus.Rejectd,
  LombardTransactiionStatus.Expired,
  LombardTransactiionStatus.Failed,
];
